import styled from 'styled-components';

export const CircleOutline = styled.div`
    width: 210px;
    height: 210px;
    border-radius: 1000px;
    background: ${props => (props.outline ? props.outline : 'white')};
    margin: 10px;
    padding: 3px;
`;

export const CircleBody = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 1000px;
    background-color: #0e0e0e;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    ${props => {
        if (props.dashed) {
            return `
                width: 208px;
                height: 208px;
                border: 3px dashed rgba(255, 255, 255, 0.15);
                margin: 10px;
                padding: 30px;
                justify-content: center;
            `;
        }
    }};
`;

export const CirclesContainer = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
`;

export const Content = styled.div`
    width: 100%;
    height: calc(100vh - 160px);
    overflow: auto;
    padding: 20px;
    display: ${props => (props.display ? props.display : 'flex !important')};
    flex-wrap: wrap;
    align-content: flex-start;
    outline: none !important;
`;

export const WorkoutOwnerAvatar = styled.div`
    width: 65px;
    height: 65px;
    border-radius: 50%;
    border: none;
    background-image: url(${props => (props.background ? props.background : '')});
    background-size: cover;
    margin-left: 10px;
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/LiveDisplay/Content/style.js